module.exports = __webpack_public_path__ + "static/media/olake-product-5.82a5e19e.svg";